import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "iconsax-reactjs";
import { FaShoppingCart } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useCart } from "../context/CartContext"; // اضافه شده
import { CDN_BASE_URL } from "../config";
import { httpReauest } from "../utils/httpRequest";
import { toast } from "react-toastify";
import AddressModal from "../components/common/modal/AddressModal";

const DELIVERY_COST = 6;

const CartPage = () => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [firstOrder, setfirstOrder] = useState(false);
  const [paymentType, setPaymentType] = useState("cash");
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser) return;
    try {
      const res = await httpReauest(
        "GET",
        `/user/info/${storedUser._id}`,
        {},
        { "x-access-token": storedUser.token }
      );
      setUser(res.data.data?.user);
      setfirstOrder(res.data.data?.firstOrder);
    } catch (err) {
      console.error("خطا در دریافت اطلاعات کاربر", err);
    }
  };

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { cartItems, updateQuantity, resetCart } = useCart(); // استفاده از context

  const orderTotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  const finalAmount = orderTotal + (firstOrder ? 0 : DELIVERY_COST);

  const handleOrderSubmit = async () => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser || !user?.selectedAddress) {
      toast.error(t("no_address_selected"));
      return;
    }

    const orderPayload = {
      user: storedUser._id,
      address: user.selectedAddress._id,
      paymentType,
      items: cartItems.map((item) => ({
        product: item._id,
        quantity: item.quantity,
        price: item.price,
      })),
      deliveryCost: DELIVERY_COST,
      total: orderTotal,
      finalAmount: finalAmount,
    };

    try {
      const res = await httpReauest("POST", "/order/create", orderPayload, {
        "x-access-token": storedUser.token,
      });
      if (res.status === 201) {
        resetCart();
        toast.success(t("order_success"));
        navigate("/profile/orders"); // مسیر صفحه سفارشات
      }
    } catch (err) {
      toast.error(t("order_error"));
      console.error("خطا در ثبت سفارش:", err);
    }
  };

  return (
    <div className="min-h-screen flex flex-col px-4 pb-32 relative">
      <AddressModal
        show={showAddressModal}
        setShow={setShowAddressModal}
        getData={fetchUser}
        selectedAddress={user?.selectedAddress?._id}
      />
      {showPaymentModal && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-50"
            onClick={() => setShowPaymentModal(false)}
          ></div>
          <div className="fixed bottom-[0px] left-0 right-0 bg-white p-5 rounded-t-xl z-[55] max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-bold mb-4">
              {t("choose_payment_method")}
            </h3>

            {/* انتخاب روش پرداخت */}
            <div className="space-y-3 mb-6">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  value="cash"
                  checked={paymentType === "cash"}
                  onChange={() => setPaymentType("cash")}
                />
                <img
                  src="/cash-on-delivery.png"
                  className="w-8"
                  alt="Delivery icon"
                />
                {t("payment_cash")}
              </label>
              <label className="flex items-center gap-2 border-t pt-2">
                <input
                  type="radio"
                  value="visa"
                  checked={paymentType === "visa"}
                  onChange={() => setPaymentType("visa")}
                />
                <img src="/visa.png" className="w-8" alt="Visa Icon" />
                {t("payment_visa")}
              </label>
            </div>

            {/* آدرس انتخابی */}
            <div className="bg-gray-50 rounded-lg p-3 mb-4 border">
              <div className="flex justify-between items-center">
                <div>
                  <h4 className="font-semibold text-sm">
                    {t("selected_address")}
                  </h4>
                  <p className="text-xs text-gray-600">
                    {user?.selectedAddress?.name || t("no_address_selected")}
                  </p>
                </div>
                <button
                  onClick={() => {
                    setShowPaymentModal(false);
                    setShowAddressModal(true); // این مربوط به AddressModal است
                  }}
                  className="text-blue-500 text-sm font-medium"
                >
                  {t("change")}
                </button>
              </div>
            </div>

            <button
              onClick={() => {
                // ارسال سفارش در اینجا انجام می‌شود
                setShowPaymentModal(false);
                handleOrderSubmit();
              }}
              className="w-full bg-[var(--primary)] text-white py-2 rounded-lg mt-2"
            >
              {t("confirm_payment")}
            </button>
          </div>
        </>
      )}

      <div className="flex justify-end py-4">
        <button onClick={() => navigate(-1)}>
          <ArrowLeft />
        </button>
      </div>

      <div className="flex justify-between items-start px-3 py-2 bg-white shadow rounded-[8px]">
        <div className="flex gap-2 items-center">
          <FaShoppingCart size={22} />
          {t("cart_title")}
        </div>
      </div>

      <div className="py-4 grid gap-3">
        {cartItems.length === 0 ? (
          <p>{t("cart_empty")}</p>
        ) : (
          cartItems.map((item) => (
            <div
              key={item.id}
              className="flex justify-between items-center p-4 bg-white rounded shadow flex-wrap"
            >
              <div className="w-full flex gap-2 items-center">
                <img
                  alt={item.name}
                  src={CDN_BASE_URL + item.img}
                  className="w-16 h-16 rounded-lg border p-1"
                />
                <h4 className="font-bold">
                  {" "}
                  {i18n.language === "en" ? item.name_en : item.name}
                </h4>
              </div>
              <div>
                <p className="text-sm text-gray-800">
                  {item.price.toLocaleString()} {t("rial")}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => updateQuantity(item.id, -1)}
                  className="px-2 py-1 bg-red-100 rounded"
                >
                  -
                </button>
                <span>{item.quantity}</span>
                <button
                  onClick={() => updateQuantity(item.id, 1)}
                  className="px-2 py-1 bg-green-100 rounded"
                >
                  +
                </button>
              </div>
            </div>
          ))
        )}

        {cartItems.length > 0 && (
          <div className="p-4 mt-4 bg-white rounded shadow border-t border-gray-100">
            <h3 className="text-lg font-bold mb-4">{t("cart_invoice")}</h3>
            <div className="flex justify-between mb-2">
              <span>{t("cart_total")}</span>
              <span>
                {orderTotal.toLocaleString()} {t("rial")}
              </span>
            </div>
            <div className="flex justify-between mb-2">
              <span>{t("cart_delivery")}</span>
              <span>
                {firstOrder
                  ? t("free")
                  : `${DELIVERY_COST.toLocaleString()} ${t("rial")}`}
              </span>
            </div>
            <div className="flex justify-between font-bold text-lg mt-4 border-t pt-3">
              <span>{t("cart_payable")}</span>
              <span>
                {finalAmount.toLocaleString()} {t("rial")}
              </span>
            </div>
          </div>
        )}
      </div>

      {cartItems.length > 0 && (
        <div className="fixed bottom-0 left-0 right-0 bg-white shadow-xl border-t p-4 flex justify-between items-center z-50">
          <div className="font-bold text-lg">
            <p className="text-sm font-medium">{t("cart_payable")}</p>
            {finalAmount.toLocaleString()} {t("rial")}
          </div>
          <button
            className="bg-[var(--primary)] text-white px-6 py-2 rounded-lg"
            onClick={() => setShowPaymentModal(true)}
          >
            {t("cart_pay")}
          </button>
        </div>
      )}
    </div>
  );
};

export default CartPage;
